export default function Footer() {
  return (
    <footer id="footer" className="w-full bg-background-900 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10 mb-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-movie-2-line text-2xl text-accent-400"></i>
              </div>
              <span className="font-heading text-xl font-bold text-white">窝窝影院</span>
            </div>
            <p className="text-white/50 text-sm leading-relaxed">
              窝窝影院提供<strong className="text-white/70">免费在线观看</strong>、免费影视资源，
              <strong className="text-white/70">免费高清视频</strong>免费追剧，最新电影电视剧大全不缓冲，
              无广告全部免费<strong className="text-white/70">每日更新</strong>精彩内容。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-white mb-4">快速导航</h4>
            <div className="grid grid-cols-2 gap-2">
              {[
                { label: '热播榜单', href: '#ranking' },
                { label: '精彩推荐', href: '#media' },
                { label: '影视专题', href: '#cards' },
                { label: '精选专题', href: '#carousel' },
                { label: '影视索引', href: '#index' },
                { label: '常见问题', href: '#faq' },
                { label: '关于我们', href: '#about' },
                { label: '联系我们', href: '#contact' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-white/45 hover:text-accent-400 text-sm transition-colors cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-white mb-4">合作伙伴</h4>
            <p className="text-white/35 text-sm leading-relaxed">
              感谢所有合作伙伴对窝窝影院的支持与信任。
              我们期待与更多优质内容方和技术伙伴携手，
              共同为影迷打造更好的免费观影体验。
            </p>
          </div>
        </div>

        <div className="pt-6 border-t border-white/10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/30">
            <p>&copy; 2025 窝窝影院 wowocinema.com - 免费高清影视在线观看平台</p>
            <div className="flex items-center gap-4">
              <span>完全免费</span>
              <span className="w-px h-3 bg-white/15"></span>
              <span>高清播放</span>
              <span className="w-px h-3 bg-white/15"></span>
              <span>每日更新</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}